import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import SetupLayer from "../components/SetupLayer";

const SetupPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Onboarding">
        <SetupLayer />
      </MasterLayout>
    </>
  );
};

export default SetupPage;
